import React from 'react';
import {useGeneralStationsStyles} from 'Features/StationsNew/useStyles';
import {Pane} from 'evergreen-ui';
import {MemoStationsFiltersMonitoring} from "../Filers/Station/StationsFiltersMonitoring";
import DatasourcesFilterMonitoring from "../Filers/Datasource/FilterMonitoring";
import {MemoStationsFoundCountMonitoring} from "../Filers/Station/FoundCountMonitoring";
import {MemoResetFiltersMonitoring} from "./ResetFiltersMonitoring";
import {useResetFiltersMonitoring} from "../Hooks/useResetFiltersMonitoring";

export default function StationsFilterFullMonitoring() {
    const classes = useGeneralStationsStyles();
    // note: айди будут по возрастанию, а значит и отображаться также - не знаю так надо или нет
    const { disabledReset, onClickReset } = useResetFiltersMonitoring();
    return (
        <Pane padding=".5rem" display="flex" flexDirection="column" gap=".2rem">
            <Pane className={classes.filterRow} gridTemplateColumns="1fr max-content">
                <MemoStationsFiltersMonitoring />
            </Pane>

            <Pane className={classes.filterRow} gridTemplateColumns="1fr max-content max-content">
                <DatasourcesFilterMonitoring />
                <MemoStationsFoundCountMonitoring justifySelf="end" />
                <MemoResetFiltersMonitoring onClick={onClickReset} disabled={disabledReset} />
            </Pane>
        </Pane>
    );
}
